import { render } from "./BsPageNav.vue?vue&type=template&id=75c61edc&scoped=true"
import script from "./BsPageNav.vue?vue&type=script&lang=js"
export * from "./BsPageNav.vue?vue&type=script&lang=js"

import "./BsPageNav.vue?vue&type=style&index=0&id=75c61edc&scoped=true&lang=css"

import exportComponent from "/Users/mae/Dev/mamp/htdocs/mfj_renewal/manage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75c61edc"]])

export default __exports__